import { useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

// Opens an announcement link: app page, property, external URL or portal tab.
export const useOpenAnnouncementLink = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  return useCallback((link) => {
    if (!link?.target) return;
    if (link.type === 'external') { window.open(link.target, '_blank', 'noopener,noreferrer'); return; }
    if (link.type === 'property') { navigate(`/properties?focus=${encodeURIComponent(link.target)}`); return; }
    if (link.type === 'portal_tab') {
      navigate(`${pathname}?tab=${encodeURIComponent(link.target)}`, { state: { ts: Date.now() } });
      return;
    }
    navigate(link.target);
  }, [navigate, pathname]);
};

export const linkCta = (link) => link?.label || (link?.type === 'property' ? 'Voir le bien' : link?.type === 'external' ? 'Ouvrir le lien' : 'Voir');
